import classes from './nickname-textbox.module.css';

const NickNameTextBox: React.FC<{ type: string; id: string; placeholder: string }> = (props) => {

  return (

        <input
          name={props.id}
          type={props.type}
          id={props.id}
          className={classes.textbox}
          placeholder={props.placeholder}
        />

  );
};

export default NickNameTextBox;
